import Actions from "../Hospitals/Transactions/Actions";

export const hospitalTransactions = [
  {
    id: 1,
    date: "02/07/2024",
    invoiceNumber: "INV-042",
    transactionName: "Test",
    dueDate: "02/07/2024",
    status: "Overdue",
    total: "₹92.04",
    balance: "₹70.04",
    actions: <Actions/>,
  },
  {
    id: 2,
    date: "02/07/2024",
    invoiceNumber: "INV-042",
    transactionName: "Test",
    dueDate: "02/07/2024",
    status: "Overdue",
    total: "₹92.04",
    balance: "₹70.04",
    actions: <Actions/>,
  },{
    id: 3,
    date: "02/07/2024",
    invoiceNumber: "INV-042",
    transactionName: "Test",
    dueDate: "02/07/2024",
    status: "Overdue",
    total: "₹92.04",
    balance: "₹70.04",
    actions: <Actions/>,
  },
];
